import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import PurchaseOrderListResults from 'components/PurchaseOrders/PurchaseOrderListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  products: state.products,
  vendors: state.vendors,
  purchaseOrders: state.purchaseOrders,
  productCategories: state.categories.productCategories,
  productCompanies: state.categories.productCompanies,
  idGen: state.idGen,
  user: state.user
});

const PurchaseOrderList = (props) => (
  <>
    <Helmet>
      <title>Purchase Orders | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <PurchaseOrderListResults
          activeUserId={props.activeUserId}
          products={props.products}
          vendors={props.vendors}
          purchaseOrders={props.purchaseOrders}
          productCategories={props.productCategories}
          productCompanies={props.productCompanies}
          idGen={props.idGen}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (PurchaseOrderList);